export class MovingAverage {
  private _values: number[] = [];
  private _sum: number = 0;

  constructor(private _windowSize: number) {}

  addValue(value: number): number {
    this._sum += value;
    this._values.push(value);
    if (this._values.length > this._windowSize) {
      const firstElement = this._values.shift();
      if (firstElement) {
        this._sum -= firstElement;
      }
    }

    return Math.floor(this._sum / this._values.length);
  }
}
